module.exports = __webpack_public_path__ + "img/8.a17bb927.png";